import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { ISiteUser } from '~src/userManagement/users/serverApi/types/ISiteUser';

export function addToIdentityPoolOnSiteRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.18',
    httpMethod: 'POST',
    endpoint: `users/identityPool`,
    serverWideRequest: false
  };
}

interface UserType {
  user: {
    name: string;
    id: string;
    authSetting: string;
    identityPoolUuid: string;
    identityUuid: string;
  };
}

export function callAddToIdentityPoolOnSiteRequest(siteUser: ISiteUser, identityUuid: string, poolId: string): Promise<IResult> {
  return makeJsonRestApiRequest<UserType, IResult>({
    config: addToIdentityPoolOnSiteRequestConfig(),
    request: {
      user: {
        name: siteUser.username,
        id: siteUser.luid,
        authSetting: siteUser.authSetting,
        identityPoolUuid: poolId,
        identityUuid: identityUuid
      }
    },
  });
}
